export default {
    filters: {
        truncate(val, length=20) {
            return val.substring(0, length) + (val.length > length ? "..." : '');
        }
    }
}